import React from 'react';
import { COLORS, DARK_THEME } from '../../constants/colors';
import { useTheme } from '../../context/ThemeContext';
import { useLanguage } from '../../context/LanguageContext';
import { APP_LINKS } from '../../constants/appLinks';
import appIcon from '../../assets/app/app-icon.png';
import appStoreBadgeEn from '../../assets/app/app-store-badge-en.svg';
import appStoreBadgeTr from '../../assets/app/app-store-badge-tr.svg';
import googlePlayBadgeEn from '../../assets/app/google-play-badge-en.png';
import googlePlayBadgeTr from '../../assets/app/google-play-badge-tr.png';

const AppDownload = () => {
  const { isDarkMode } = useTheme();
  const { language } = useLanguage();
  const isTr = language === 'tr';

  return (
    <section style={{
      ...styles.section,
      background: isDarkMode
        ? `linear-gradient(135deg, ${DARK_THEME.background} 0%, ${DARK_THEME.surface} 100%)`
        : `linear-gradient(135deg, ${COLORS.primary} 0%, ${COLORS.primaryDark} 100%)`,
    }}>
      <div style={styles.container}>
        <div style={styles.iconWrap}>
          <img
            src={appIcon}
            alt="Turkic Silk Road App"
            style={styles.appIcon}
          />
        </div>
        <div style={styles.content}>
          <span style={{
            ...styles.badge,
            backgroundColor: isDarkMode ? `${DARK_THEME.primary}25` : 'rgba(255,255,255,0.2)',
            color: isDarkMode ? DARK_THEME.primary : COLORS.white,
          }}>
            {isTr ? 'Mobil Uygulama' : 'Mobile App'}
          </span>
          <h2 style={{
            ...styles.title,
            color: isDarkMode ? DARK_THEME.textPrimary : COLORS.white,
          }}>
            {isTr ? 'Turkic Silk Road Artık Cebinizde' : 'Turkic Silk Road, Now in Your Pocket'}
          </h2>
          <p style={{
            ...styles.description,
            color: isDarkMode ? DARK_THEME.textSecondary : 'rgba(255,255,255,0.85)',
          }}>
            {isTr
              ? 'Üye devletleri, İpek Yolu rotalarını, turizm noktalarını ve son haberleri mobil uygulamamızla keşfedin. Ücretsiz indirin.'
              : 'Explore member states, Silk Road routes, tourism sites, and the latest news with our mobile app. Download for free.'}
          </p>
          <div style={styles.badges}>
            <a
              href={APP_LINKS.appStore}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="App Store"
            >
              <img
                src={isTr ? appStoreBadgeTr : appStoreBadgeEn}
                alt={isTr ? "App Store'dan İndirin" : 'Download on the App Store'}
                style={styles.appStoreBadge}
              />
            </a>
            <a
              href={APP_LINKS.googlePlay}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Google Play"
            >
              <img
                src={isTr ? googlePlayBadgeTr : googlePlayBadgeEn}
                alt={isTr ? "Google Play'den alın" : 'Get it on Google Play'}
                style={styles.googlePlayBadge}
              />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

const styles = {
  section: {
    padding: '80px 20px',
  },
  container: {
    maxWidth: '1200px',
    margin: '0 auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: '50px',
  },
  iconWrap: {
    flexShrink: 0,
  },
  appIcon: {
    width: '160px',
    height: '160px',
    borderRadius: '36px',
    boxShadow: '0 20px 50px rgba(0,0,0,0.35)',
  },
  content: {
    flex: '1 1 400px',
    maxWidth: '600px',
  },
  badge: {
    display: 'inline-block',
    padding: '6px 16px',
    borderRadius: '20px',
    fontSize: '14px',
    fontWeight: '600',
    marginBottom: '16px',
  },
  title: {
    fontSize: 'clamp(28px, 4vw, 40px)',
    fontWeight: '700',
    marginBottom: '16px',
    lineHeight: '1.2',
  },
  description: {
    fontSize: '17px',
    lineHeight: '1.7',
    marginBottom: '28px',
  },
  badges: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '16px',
  },
  appStoreBadge: {
    height: '52px',
    display: 'block',
  },
  // Google Play rozetinin PNG'sinde kenar boşluğu gömülü olduğundan
  // App Store rozetiyle aynı görünmesi için daha yüksek tutulur
  googlePlayBadge: {
    height: '78px',
    display: 'block',
    margin: '-13px 0',
  },
};

export default AppDownload;
